export default "__VITE_ASSET__CxRGyQwV__"